import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';

export type VhSkeletonVariant = 'text' | 'circle' | 'rect';

/**
 * Pulsing placeholder for loading states. All props optional — defaults to
 * a 100%-width single-line text shimmer.
 */
@Component({
  selector: 'vh-skeleton',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `<span class="vh-skel vh-skel--{{ variant() }}" [style]="style()"></span>`,
  styleUrl: './skeleton.component.scss',
})
export class VhSkeletonComponent {
  readonly variant = input<VhSkeletonVariant>('text');
  readonly width = input<string>();
  readonly height = input<string>();

  readonly style = computed(() => {
    const w = this.width();
    const h = this.height();
    const parts: string[] = [];
    if (w) parts.push(`width:${w}`);
    if (h) parts.push(`height:${h}`);
    return parts.join(';');
  });
}
